import React from 'react'
import { Box, Button, FieldLabel, Modal, ModalNavHeader, TextInput } from 'elements'
import DatePeriodInput from 'components/ui/input/DatePeriodInput'

export default function IntegrationSubmitStep({
  onBack,
  onClose,
  submitting,
  reportPeriod,
  setReportPeriod,
  reportName,
  setReportName,
  valid,
  handleCreate,
}) {
  return (
    <>
      <ModalNavHeader onClose={onClose} titleText="Finish Report" onBack={onBack} />
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        p="xxlarge"
        overflowY="auto"
        pb="xgigantic"
      >
        <Box mb="xlarge">
          <FieldLabel>Report period</FieldLabel>
          <DatePeriodInput disabled={submitting} value={reportPeriod} onChange={setReportPeriod} />
        </Box>
        <Box mb="medium">
          <FieldLabel>Name this report (optional)</FieldLabel>
          <TextInput
            disabled={submitting}
            value={reportName}
            onChange={(event) => setReportName(event.target.value)}
            placeholder="Anomaly Report"
          />
        </Box>
      </Box>
      <Modal.Footer display="flex" alignItems="center">
        <Button disabled={!valid || submitting} mr="medium" kind="secondary" onPress={handleCreate}>
          {submitting ? 'Creating...' : 'Create Report'}
        </Button>
        <Button disabled={submitting} onPress={onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </>
  )
}
